import(/* webpackMode: "eager", webpackExports: ["SearchClient"] */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/search/search-client.tsx");
